import gql from 'graphql-tag'
import {
	main as cashRegisterFragment
} from './fragments'

const mutation = gql`
mutation createCashRegister($fields: CashRegisterReqInput!, $deviceType: cashRegisterType!, $settingsCopyId: ID, $hardwareId: ID, $deactivateAllContent: Boolean) {
	cashAssist {
	  createCashRegister(
	    fields: $fields,
	    deviceType: $deviceType,
	    settingsCopyId: $settingsCopyId,
	    hardwareId: $hardwareId,
	    deactivateAllContent: $deactivateAllContent
	  ) {
	  	id
	    ...cashRegisterMain
	  }
	}
}
${cashRegisterFragment}`

export default mutation
